module.exports = __webpack_public_path__ + "img/关闭同捆.15ad6541.svg";